/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".c-profile-history[_ngcontent-%COMP%]{height:1px!important;overflow:hidden;display:none}"];
export { styles as styles };
